import { render, staticRenderFns } from "./Estimates.vue?vue&type=template&id=667f8270&scoped=true"
import script from "./Estimates.vue?vue&type=script&lang=js"
export * from "./Estimates.vue?vue&type=script&lang=js"
import style0 from "./Estimates.vue?vue&type=style&index=0&id=667f8270&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667f8270",
  null
  
)

export default component.exports